/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useMemo } from 'react';
import {
	useEntryPointButtonTrigger,
	getDefaultEntrypointActionEventMap,
} from '@jira/platform__entry-point-button-trigger/src/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import type { EntryPointActions } from '@jira/platform__entry-point/src/controllers/utils/types.tsx';

export type ExpandableEntryPointTrigger = (element: HTMLElement | null) => void;

export const useExpandableEntryPointTrigger = (
	actions: EntryPointActions,
	isActive = true,
): ExpandableEntryPointTrigger => {
	// We don't want the click-handler, as ExpandableMenuItem handles the entry-point loading itself
	const eventMap = useMemo(
		() =>
			Object.fromEntries(
				Object.entries(getDefaultEntrypointActionEventMap(actions)).filter(
					([key]) => key !== 'click',
				),
			),
		[actions],
	);

	return useEntryPointButtonTrigger(actions, isActive, eventMap);
};
